import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Route guard for /workday-client/checkout.
 *
 * Waits for full auth hydration (session + user + userType all resolved),
 * then enforces: must be an authenticated workday_services_client.
 *
 * Billing state (plan + pending_checkout) is checked inside the Checkout
 * page itself, which keeps the routing concern separate from DB state.
 */
export default function BillingGateRoute({ children }: { children: React.ReactNode }) {
  const { user, userType, authHydrated } = useAuth();
  const location = useLocation();

  console.log('[BillingGateRoute]', {
    authHydrated,
    userState: user === undefined ? 'undefined' : user === null ? 'null' : user.id,
    userType,
    location: location.pathname,
    ts: Date.now(),
  });

  // undefined = auth still initializing — show spinner, never redirect
  // null      = confirmed no session — redirect to login
  // User obj  = authenticated — proceed to userType check
  //
  // We also wait for userType to resolve (not undefined) before enforcing the
  // role check — otherwise a briefly-undefined userType would wrongly redirect
  // a valid workday_services_client to the dashboard.
  if (!authHydrated || user === undefined || userType === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#40E0D0]" />
      </div>
    );
  }

  if (user === null) {
    console.log('[BillingGateRoute] REDIRECT TO LOGIN', { user, userType, authHydrated });
    return <Navigate to="/customer/login" state={{ from: location }} replace />;
  }

  if (userType !== 'workday_services_client') {
    console.log('[BillingGateRoute] REDIRECT TO DASHBOARD (wrong role)', { userType });
    return <Navigate to="/workday-client/dashboard" replace />;
  }

  return <>{children}</>;
}
